import { Directive, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/tooltip";
/**
 * to be used together with the matTooltip directive
 * to show tooltips only if the cell content overflows the column width.
 * Used to circumnavigate the ExpressionChangedAfterItHasBeenCheckedError
 *
 * @property tooltipElement - Set `tooltipElement` to an element, if the overflow should be detected from a different element
 */
export class TooltipOnEllipsisV2Directive {
  elementRef;
  el;
  primeNgTooltip;
  // you can pass an specific HTML element here if the ellipsis should be detected from
  // another element e.g. a child element
  tooltipElement;
  tooltipDisabled;
  // set to true if you use the exported directive
  domElement;
  resizeObserver;
  constructor(elementRef, el, primeNgTooltip) {
    this.elementRef = elementRef;
    this.el = el;
    this.primeNgTooltip = primeNgTooltip;
    // Has to be any here, since this could be a variety of different elements
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.domElement = this.elementRef.nativeElement;
    this.resizeObserver = new ResizeObserver(this.setToolTip.bind(this));
  }
  ngAfterViewInit() {
    this.resizeObserver.observe(this.domElement);
  }
  ngAfterViewChecked() {
    this.setToolTip();
  }
  ngOnDestroy() {
    this.resizeObserver.unobserve(this.domElement);
  }
  setToolTip() {
    const el = this.tooltipElement ? this.tooltipElement : this.domElement;
    const overflowing = el.scrollWidth > el.offsetWidth || el.scrollHeight > el.offsetHeight;
    if (this.primeNgTooltip) {
      this.primeNgTooltip._tooltipOptions.disabled = !overflowing || this.tooltipDisabled;
      return !overflowing;
    } else {
      throw new Error('You are using the directive TooltipOnEllipsisDirective without a primeNg Tooltip');
    }
  }
  static ɵfac = function TooltipOnEllipsisV2Directive_Factory(t) {
    return new (t || TooltipOnEllipsisV2Directive)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.Tooltip));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TooltipOnEllipsisV2Directive,
    selectors: [["", "geauiTooltipOnEllipsisV2", ""]],
    inputs: {
      tooltipElement: "tooltipElement",
      tooltipDisabled: "tooltipDisabled"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipOnEllipsisV2Directive, [{
    type: Directive,
    args: [{
      selector: '[geauiTooltipOnEllipsisV2]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i1.Tooltip
  }], {
    tooltipElement: [{
      type: Input
    }],
    tooltipDisabled: [{
      type: Input
    }]
  });
})();
